esquire.define('App/SubscribeForm', [], function() {
    let widget = null;
    let input = null;

    const validate = function(email) {
        const re = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
        return re.test(email);
    };

    const show_error = function(text, old_val) {
        widget.addClass('error');
        input.val(text);
        input.attr('readonly', 'readonly');

        const removeError = function() {
            input.off('click');
            window.clearTimeout(to);
            widget.removeClass('error');
            input.val(old_val);
            input.removeAttr('readonly');
        };

        input.on('click', function() {
            removeError();
        });

        var to = window.setTimeout(removeError, 2000);
    };

    return function(post_url, csrf_token, invalid_email_text = 'Invalid email', error_text = 'Error occurred, please try again') {
        widget = $('.subscribe-widget');
        input = $('#subscribe-email');

        $('#subscribe').click(function() {
            const email = input.val();

            if (validate(email)) {
                widget.addClass('processing');

                $.ajax(post_url, {
                    headers: {
                        'X-XSRF-TOKEN': csrf_token
                    },
                    method: 'POST',
                    data: {
                        email
                    },
                    success() {
                        return widget.removeClass('processing').addClass('done');
                    },
                    error(xhr) {
                        if ((xhr.responseJSON != null) && (xhr.responseJSON.email != null)) {
                            show_error(xhr.responseJSON.email[0], email);
                        } else {
                            show_error(error_text, email);
                        }
                    }
                }
                );
            } else {
                show_error(invalid_email_text, email);
            }

        });
    };
});

